var $384a15a899b42310$exports = {};
$384a15a899b42310$exports = {
    "collapse": `Daralt`,
    "expand": `Geni\u{15F}let`
};


export {$384a15a899b42310$exports as default};
//# sourceMappingURL=tr-TR.module.js.map
